import { render, staticRenderFns } from "./legendBox4.vue?vue&type=template&id=7321afb6&scoped=true&"
import script from "./legendBox4.vue?vue&type=script&lang=js&"
export * from "./legendBox4.vue?vue&type=script&lang=js&"
import style0 from "./legendBox4.vue?vue&type=style&index=0&id=7321afb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321afb6",
  null
  
)

export default component.exports